<template>
  <div class="container">
    <section>
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div>
            <div class="card text-center">
              <div class="card-header">
                <h1>Privacy Policy</h1>
              </div>
              <div class="card-body">
                <div>
                  <div>
                    <h3>INTRODUCTION</h3>
                    <p>Welcome to the University of Law privacy notice.</p>
                    <p>
                      The University of Law takes the protection of your
                      personal data very seriously and it is very important to
                      us. Any reference to data in this notice refers to your
                      personal data i.e. any information that may directly or
                      indirectly identify you. The following paragraphs provide
                      information about what we do with your data, in particular
                      how we use your data and with whom we share your data. We
                      are obliged to provide this information under the EU
                      General Data Protection regulation (GDPR) and the Data
                      Protection Act 2018.
                    </p>
                    <p>
                      This privacy notice aims to give you information on how
                      the University of Law collects and processes your personal
                      data including any data that you may provide when applying
                      for any courses with us.
                    </p>
                    <p>
                      <strong
                        >Please read the following information
                        carefully.</strong
                      >
                    </p>
                    <p>
                      We process data both within and outside the European
                      Economic Area (EEA). We process all data in line with
                      applicable data protection requirements.
                    </p>
                    <p>
                      <strong
                        >Note on transfer of third-party data by the student. If
                        you provide us with personal data relating to your
                        parents, spouse,civil partner, relative or other third
                        party, you are responsible for complying with the
                        relevant data protection requirements. It may be
                        necessary for you to obtain the consent of the person to
                        transfer their data i.e. providing contact details in
                        the case of an emergency.</strong
                      >
                    </p>
                    <p><strong>Data Controller</strong></p>
                    <p>
                      The University of Law (&ldquo;The University of Law
                      &ldquo;also referred to in this notice as &ldquo;we&rdquo;
                      or &ldquo;us&rdquo;) is a data controller of your data and
                      is part of The Global University Systems B.V. group of
                      companies which is made up of different legal entities,
                      details of which can be found at
                      https://www.globaluniversitysystems.com. The University of
                      Law registered address in England and Wales is Braboeuf
                      Manor, St Catherines, Guildford, Surrey, GU3 1HA, United
                      Kingdom
                    </p>
                    <p><strong>Our Data Protection Officer</strong></p>
                    <p>
                      If you have any questions about the University's privacy
                      policies, please contact the Data Protection Officer at
                      The University of Law, Data Protection Officer, 2 Bunhill
                      Row, Moorgate, London, EC1Y 8HW. E-mail dpo@law.ac.uk
                    </p>
                    <p><strong>Where do we obtain your data from?</strong></p>
                    <p>
                      We obtain the data directly from you or a third party that
                      you have authorised to share your data with us e.g. UCAS
                    </p>
                    <p>
                      We will also obtain data directly from you throughout the
                      life of your agreement with us, this may be via letter or
                      e-mails that you send to us. We may also collect the
                      following data:
                    </p>
                    <p><strong>Special Category Data</strong></p>
                    <p>
                      When you make an application for a course or programme we
                      will ask whether you have any disabilities. You are not
                      obliged to inform us but any information you do provide
                      will assist us to assess how we will meet our Legal and
                      Statutory obligation in relation to your disability.
                      Special category data in this context refers to data that
                      we share with our Disability Support Service, such as:
                    </p>
                    <ul>
                      <li>Physical disabilities and impairments</li>
                      <li>
                        Specific learning difficulties (e.g. Dyslexia and
                        ADD/ADHD),
                      </li>
                      <li>
                        Autistic Spectrum Conditions (e.g. Autism, Asperger's
                        syndrome)
                      </li>
                      <li>
                        Mental health conditions (e.g. anxiety and depression)
                      </li>
                      <li>
                        Long term medical conditions (e.g. diabetes, cancer,
                        arthritis)
                      </li>
                    </ul>
                    <p><strong>Criminal Offence Data</strong></p>
                    <p>
                      For the purposes of compliance with our Safeguarding
                      Policy, we may ask for DBS checks or seek criminal records
                      information in certain circumstances (we will always
                      notify you beforehand if we require this information).This
                      type of data is regulated under the GDPR and we ensure
                      that we limit the use of any such data both in time and in
                      scope and that we meet appropriate lawful grounds for
                      processing such data.
                    </p>
                    <p>
                      For further information please contact us at dpo@law.ac.uk
                    </p>
                    <p>
                      <strong
                        >If you fail to provide us with your Personal
                        Data</strong
                      >
                    </p>
                    <p>
                      Where we need to collect personal data by law, or under
                      the terms of a contract we have with you and you fail to
                      provide that data when requested, we may not be able to
                      perform the contract we have or are trying to enter into
                      with you (for example, to provide you with goods or
                      services). In this case, we may have to cancel a product
                      or service you have with us but we will notify you if this
                      is the case at the time.
                    </p>
                    <p>
                      We also obtain your data from the following sources, if it
                      is necessary in the context of our relationship with you,
                      and in line with the relevant data protection laws:
                    </p>
                    <ul>
                      <li>
                        Companies that introduce you to us, (e.g. Global
                        University Systems, UCAS etc.)
                      </li>
                      <li>Publically available information sources</li>
                      <li>Regulatory bodies</li>
                      <li>Agents or Service providers working on our behalf</li>
                      <li>Market researchers</li>
                      <li>
                        Your employer (when they are sponsoring you to study
                        with us)
                      </li>
                    </ul>
                    <p><strong>The Data we collect about you.</strong></p>
                    <p>
                      Personal data, or personal information, means any
                      information about an individual from which that person can
                      be identified. Anonymous data is therefore not treated as
                      personal data.
                    </p>
                    <p>
                      We have grouped together different kinds of personal data
                      which <em>we</em><em>may</em> collect, use, store and
                      transfer as follows:
                    </p>
                    <p>
                      <strong>Academic Data</strong> includes eligibility data
                      such as education and academic history, training records,
                      qualifications, personal statements, CVs, personal
                      achievements and references.
                    </p>
                    <p>
                      <strong>Identity Data </strong>includes first name, maiden
                      name, last name, username or similar identifier, marital
                      status, title, date of birth and gender, NI number, Unique
                      Learner Number, nationality, residency status, disability
                      declaration, criminal conviction declaration, third party
                      student reference number where a third party shares your
                      data with us (e.g. UCAS, HESA and similar such
                      organisations) and photographic images.
                    </p>
                    <p>
                      <strong>Contact Data</strong> includes billing address,
                      term-time and permanent residential address, country of
                      residence, personal email address and telephone numbers.
                    </p>
                    <p>
                      <strong>Emergency Contact Data</strong> about next of kin
                      names and contact details for use if there is an emergency
                      that has involved you.
                    </p>
                    <p>
                      <strong>Employment Data</strong> if you are sponsored by
                      your employer this includes employer details, start date,
                      end dates, NI number, your job title and contact details
                      at work (email address, telephone number and postal
                      address).
                    </p>
                    <p>
                      <strong>Financial Data</strong> includes student loan
                      information, bank account and payment card details.
                    </p>
                    <p>
                      <strong>Marketing and Communications Data</strong>
                      includes your preferences in receiving marketing from us
                      and your communication preferences.
                    </p>
                    <p>
                      <strong>Profile Data</strong> includes any of your
                      usernames and passwords, enquiries made by you, purchases
                      or orders made by you, your interests, preferences,
                      feedback and survey responses.
                    </p>
                    <p>Privacy Policy</p>
                    <p>
                      <strong>Student Data</strong> includes your term time and
                      home address, ID photo, subject of interest,
                    </p>
                    <p>
                      chosen course or programme (or one of our partner
                      establishments), your progress data and your results
                      (coursework and exam, including mocks), other results from
                      throughout your studies with us, exam scripts and
                      transcripts, your attendance, lecturers' and tutors'
                      feedback on you or your employer if you are a corporate
                      student. We keep references, communications with us
                      received by you to or from your University of Law email
                      address, the extent of your use of any learning facilities
                      / services by University of Law information relating to
                      your use of the University of Law library resources
                      (including materials checked out and overdue items) and
                      print services, data about your membership of student
                      groups, associations and any event attendances,
                      information regarding mentor and mentee data, your
                      membership of any relevant alumni network, data around
                      your taking part in events hosted by us or advertised by
                      us, learner analytics and profiling data, any disciplinary
                      data, student, course, tutor- related complaints data and
                      any claims involving you of any nature whatsoever such as
                      extenuating circumstances, appeals and additional
                      information as required by
                      professional/accreditation/awarding body.
                    </p>
                    <p>
                      <strong
                        >Monitoring and Reporting Requirements Data</strong
                      >
                      includes destination of leavers and Student Data reported
                      to third parties (e.g. HESA, SLC) for regulatory purposes.
                    </p>
                    <p>
                      <strong>Transaction Data</strong> includes details about
                      payments to and from you and other details of products and
                      services you have purchased from us.
                    </p>
                    <p>
                      <strong>Visa Data</strong> for international students,
                      including passport and previous visas data, bank
                      statements or other financial information for satisfying
                      ourselves that visa requirements are met.
                    </p>
                    <p><strong>Why do we process your data?</strong></p>
                    <p>
                      We process you data in order to be able to provide our
                      services to you and in order to meet our contractual
                      obligations as follows:
                    </p>
                    <ul>
                      <li>
                        To respond to your request for a call (or email), course
                        enquiries, applications.
                      </li>
                      <li>
                        To enter into and manage our agreement with you and to
                        provide services to you under the agreement.
                      </li>
                      <li>
                        To enrol / register you as a new student and provide
                        student number / identity card.
                      </li>
                      <li>
                        To manage our relationship with you e.g. provision of
                        learning material, timetable etc.
                      </li>
                      <li>
                        Administration of appeals, complaints, matters relating
                        to health and conduct and to cheating and plagiarism
                        (unfair means).
                      </li>
                      <li>
                        Monitor attendance or any change in student status.
                      </li>
                    </ul>
                    <p>
                      We also process you data where it is necessary to do so
                      for our legitimate interest. A
                    </p>
                    <p>
                      legitimate interest is where we have a business or
                      commercial reason to process your data without it being
                      unfair to your rights or best interests, such as
                      developing and improving our courses and services,
                      performing our contractual, reporting and legal duties and
                      granting of awards. We process your data for the following
                      legitimate business purposes:
                    </p>
                    <ul>
                      <li>
                        Necessary for our legitimate interests (for running our
                        business, provision of administration and IT services,
                        network security, to prevent fraud and in the context of
                        a business reorganisation or group restructuring
                        exercise).
                      </li>
                      <li>
                        To make suggestions and recommendations to you about
                        goods or services that may be of interest to you.
                      </li>
                      <li>
                        Marketing of or about student benefits and opportunities
                        for instance University activities, events and courses
                        that may be of interest, services or career
                        opportunities and professional and industrial bodies
                        wishing to communicate with students about career
                        opportunities.
                      </li>
                      <li>Administration of alumni membership.</li>
                      <li>
                        To keep our records updated and to study how students
                        use our products/services.
                      </li>
                      <li>Equal opportunities monitoring.</li>
                      <li>
                        To process, fulfil and deliver our service to you by
                        managing payments, fees and charges collection/ recovery
                        of monies owed, accounting purposes and defence of any
                        legal claims brought against us.
                      </li>
                      <li>Seeking your feedback.</li>
                    </ul>
                    <p>
                      We may also process your data to comply with legal,
                      regulatory, reporting and other governance obligations
                      including:
                    </p>
                    <ul>
                      <li>
                        To comply with applicable laws and other regulatory and
                        reporting requirements, in particular reporting
                        attendance to the student loan company.
                      </li>
                      <li>
                        Provide health and safety, first aid assistance,
                        emergency evacuation, hazard risk assessment and
                        accident monitoring.
                      </li>
                      <li>
                        Make adjustments to meet disability requirements /
                        medical conditions in accordance with our Disability
                        Support Services (DSS).
                      </li>
                      <li>Emergency accident / health management.</li>
                    </ul>
                    <p><strong>With whom do we share your data?</strong></p>
                    <p>
                      We will share your data with our employees who require
                      such access in order to meet our contractual and statutory
                      duties. Service providers instructed by us may also
                      receive data in this context. These are companies that
                      fall within the categories of account management services,
                      IT services, logistics, printing services,
                      telecommunications, debt collection, advisory and
                      consulting services and marketing. We may also share your
                      personal data with regulatory authorities, courts and
                      tribunals, government agencies and law
                      enforcementagencies(police)whererequiredtodoso.
                    </p>
                    <p>
                      Other parties we may share your data with, including the
                      following
                    </p>
                    <ul>
                      <ul>
                        <li>
                          Our parent company Global University Systems network
                          of institutions, affiliates and partners.
                        </li>
                        <li>
                          Organisations that introduce you to us (Such as UCAS,
                          Recruitment Agencies)
                        </li>
                        <li>
                          External Examiners for examination, assessment and
                          moderation purposes
                        </li>
                        <li>
                          Professional/Funding bodies and Student Loans company
                        </li>
                        <li>
                          The UK Higher Education Statistics Agency (HESA).
                          Information on HESA's use of student data is available
                          at
                          https://www.hesa.ac.uk/about/regulation/data-protection/notices
                        </li>
                        <li>
                          Monitoring and Reporting Requirements Data reporting
                          to third parties (e.g. SLC, PSRB's, DLHE, EFSA, etc.)
                          for regulatory purposes
                        </li>
                        <li>
                          Other universities, employers, prospective employers,
                          providers of training contracts or pupillages
                        </li>
                        <li>
                          Third party systems on which data may be hosted
                          include: ELITE, Student Records Systems etc.
                        </li>
                        <li>University Guilds and Student Unions</li>
                      </ul>
                    </ul>
                    <p>
                      <strong
                        >Sending Data outside of the European Economic Area
                        (EEA)</strong
                      >
                    </p>
                    <p>
                      We may also share your data with recipients outside the
                      EEA, such as the USA and India. If we do then we will make
                      sure that it is protected in the same way as if it was
                      being processed in the EEA.
                    </p>
                    <p>
                      Some countries or territories outside the EEA do not have
                      adequate levels of data protection corresponding to the
                      general data protection regulation. In order to protect
                      your data and to achieve an adequate level of protection
                      for your personal data when we transfer it to these
                      countries or territories, we will ensure that one or more
                      of the following safeguards are put in place:
                    </p>
                    <ul>
                      <ul>
                        <li>
                          The organisation we transfer the data to may be part
                          of Privacy Shield. This is a framework that sets
                          standards for the transfer of data between the USA and
                          EU countries. It makes sure those standards are
                          similar to those used within the EEA.
                        </li>
                        <li>
                          Your data may be transferred to a non -EEA country
                          with privacy laws that give the same
                        </li>
                      </ul>
                    </ul>
                    <p>protection as the EEA.</p>
                    <ul>
                      <ul>
                        <li>
                          We may put in place a contract with the recipient that
                          means they must protect your data to the same
                          standards as within the EEA. This contract may be in
                          the form of the standard EU Contractual clauses which
                          have been approved by the European Commission.
                        </li>
                      </ul>
                    </ul>
                    <p>
                      Reasons why we may transfer your data outside the EEA
                      could include.
                    </p>
                    <ul>
                      <ul>
                        <li>
                          The transfer is necessary for the performance of a
                          contract between you and us as the data controller or
                          for the implementation of pre-contractual measures
                          taken at your request.
                        </li>
                        <li>
                          The transfer is necessary for the conclusion or
                          performance of a contract concluded in your interests
                          between us as the data controller and another natural
                          or legal person.
                        </li>
                        <li>
                          The transfer is necessary for the establishment,
                          exercise or defence of legal claims.
                        </li>
                        <li>
                          The transfer is necessary in order to protect your
                          vital interests or the vital interests of other
                          persons, where you are physically or legally incapable
                          of giving consent
                        </li>
                      </ul>
                    </ul>
                    <p>
                      To use data analytics to: improve our products, services,
                      marketing, customer
                    </p>
                    <p>
                      relationships and experiences; and for market research,
                      statistical analysis and survey purposes
                    </p>
                    <p>
                      You can learn more about this at the European Commission
                      website here
                      https://ec.europa.eu/info/law/law-topic/data-protection/data-protection-eu_en
                    </p>
                    <p>
                      You can also contact our Data Protection Officer if you
                      would like further information, using the details above.
                    </p>
                    <p>
                      <strong>How long do we keep your personal data?</strong>
                    </p>
                    <p>
                      We will keep your personal data for as long as you have an
                      agreement/contract with us. Once your agreement with us
                      comes to an end we may keep your data for up to 10 years
                      or longer for the following reasons.
                    </p>
                    <ul>
                      <ul>
                        <li>To meet our regulatory/legal responsibilities.</li>
                        <li>
                          To enable us to respond to any questions or complaints
                          that you may have.
                        </li>
                        <li>
                          To enable us to confirm your qualification/award
                          achieved during your time of study with us.
                        </li>
                      </ul>
                    </ul>
                    <p>
                      We may need to retain your data for longer if we are
                      unable to delete the data for legal, regulatory or
                      technical reasons. If this is the case we will ensure that
                      your privacy is protected.
                    </p>
                    <p><strong>Your Rights</strong></p>
                    <p>
                      You may have the following rights in relation to your
                      data:
                    </p>
                    <ul>
                      <ul>
                        <ul>
                          <li>
                            <strong>Right of access </strong>- you have a right
                            to access to your data and to certain information
                            about the processing of that personal data. This
                            information must usually be provided to you free of
                            charge within a month of receiving your request.
                            Exceptions to this are:
                          </li>
                          <ul>
                            <li>
                              Examination scripts which are specifically exempt
                              from the data subject's access
                              rightsundertheGeneralDataProtectionRegulation.Ingeneral,studentsareentitledtoknowtheirexaminationmarksbutarenotentitledtoseetheir
                              examination scripts. However, students are
                              entitled to see associated examiner's comments and
                              minutes of any examination appeals panels, which
                              are not exempt from disclosure.
                            </li>
                            <li>
                              Examination marks that have been requested before
                              the results are announced have to be disclosed
                              either within 5 months of the date of the request
                              or within 30 days of the date the results are
                              published, whichever is earlier. In practice, this
                              exemptionprevents disclosure of exam results
                              before they are officially announced
                            </li>
                          </ul>
                        </ul>
                      </ul>
                    </ul>
                    <ul>
                      <ul>
                        <li>
                          <strong>Right of rectification (correction)</strong> -
                          you have the right to ask for your personal data to be
                          corrected if it's inaccurate and completed if it's
                          incomplete.
                        </li>
                        <li>
                          <strong>Rights to be forgotten-</strong> in certain
                          circumstances you can ask us to erase your personal
                          data. It's unlikely to be possible to accept your
                          request if, for example, we have a contractual or
                          other legal duty to retain your information.
                        </li>
                      </ul>
                    </ul>
                    <p>Privacy Policy</p>
                    <ul>
                      <ul>
                        <li>
                          <strong>Right to restriction of processing -</strong>
                          in certain circumstances you have a right to restrict
                          the
                        </li>
                      </ul>
                    </ul>
                    <p>
                      processing of your personal data. This may include when
                      you dispute its accuracy (until the accuracy is proved);
                      if you have objected to the processing (when it was
                      necessary for our legitimate interest) and we are
                      considering whether our legitimate interest overrides your
                      own; or if we no longer need the data but you need us to
                      keep it in order to establish, exercise or defend a legal
                      claim.
                    </p>
                    <ul>
                      <ul>
                        <li>
                          <strong>Right of portability -</strong> in certain
                          circumstances, you have the right to move, copy or
                          transfer your
                        </li>
                      </ul>
                    </ul>
                    <p>
                      data to another data controller or to yourself. This right
                      is only relevant if the data is being processed on the
                      basis of consent or for the performance of a contract and
                      the processing is carried out by automated means. This
                      right is different from the right of access and the types
                      of information you can get under the two separate rights
                      may be different.
                    </p>
                    <ul>
                      <ul>
                        <li>
                          <strong
                            >Rights in relation to automated decision making
                            -</strong
                          >
                          you may have the right to challenge and
                        </li>
                      </ul>
                    </ul>
                    <p>
                      request a review of a decision that was made by automated
                      means.
                    </p>
                    <ul>
                      <ul>
                        <li>
                          <strong>Right to object -</strong> in certain
                          circumstances, you have the right to object to the
                          processing of your data when it is being processed on
                          the basis of our legitimate interest. We must stop
                          processing the data unless we can demonstrate that our
                          legitimate interests override your own, or if the
                          processing is necessary for legal reasons. You have an
                          absolute right to object to processing your data for
                          direct marketing purposes including profiling relevant
                          to direct marketing. If you object to us processing
                          your data for direct marketing purposes, we must
                          accept your request and stop the processing as soon as
                          we receive your objection.
                        </li>
                      </ul>
                    </ul>
                    <p>
                      <strong
                        >In order to assert any of the above rights, please
                        contact us directly using the contact details above.
                      </strong>
                    </p>
                    <p>
                      <strong
                        >In addition, you have the right to lodge a complaint in
                        relation to our processing of your data with the
                        supervisory authority, the Information Commissioner
                        (ico.org).
                      </strong>
                    </p>
                    <p>
                      <strong
                        >CHANGES TO THE PRIVACY NOTICE AND YOUR DUTY TO INFORM
                        US OF CHANGES
                      </strong>
                    </p>
                    <p>
                      <strong
                        >We may from time to time change the detail in this
                        notice. Any changes we may make in the future will be
                        posted on this page. Please check back frequently to see
                        any such updates or changes. Historic versions can be
                        obtained by contacting us.
                      </strong>
                    </p>
                    <p>
                      <strong
                        >It is important that the personal data we hold about
                        you is accurate and current. Please keep us informed if
                        your personal data changes during your relationship with
                        us.Privacy Policy</strong
                      >
                    </p>
                    <table cellspacing="0" cellpadding="0">
                      <tbody>
                        <tr>
                          <td>
                            <p>Version</p>
                          </td>
                          <td>
                            <p>Amended by</p>
                          </td>
                          <td>
                            <p>Revision summary</p>
                          </td>
                          <td>
                            <p>Date</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>V1.0</p>
                          </td>
                          <td>
                            <p>Legal</p>
                          </td>
                          <td>
                            <p>Initial drafting</p>
                          </td>
                          <td>
                            <p>Feb 2015</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>V2.0</p>
                          </td>
                          <td>
                            <p>Legal</p>
                          </td>
                          <td>
                            <p>Update</p>
                          </td>
                          <td>
                            <p>Nov 2015</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>V2.1</p>
                          </td>
                          <td>
                            <p>Academic Board</p>
                          </td>
                          <td>
                            <p>Approval</p>
                          </td>
                          <td>
                            <p>10/02/16</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>V3.0</p>
                          </td>
                          <td>
                            <p>Executive Board</p>
                          </td>
                          <td>
                            <p>Approval</p>
                          </td>
                          <td>
                            <p>24/04/18</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>V3.1</p>
                          </td>
                          <td>
                            <p>Executive Board</p>
                          </td>
                          <td>
                            <p>Approval</p>
                          </td>
                          <td>
                            <p>08/08/18</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>V3.1</p>
                          </td>
                          <td>
                            <p>No amendments</p>
                          </td>
                          <td>
                            <p>Published</p>
                          </td>
                          <td>
                            <p>Sept 2018</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>V3.2</p>
                          </td>
                          <td>
                            <p>Deputy Academic Registrar</p>
                          </td>
                          <td>
                            <p>Revision to information on HESA</p>
                          </td>
                          <td>
                            <p>July 2019</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>V3.3</p>
                          </td>
                          <td>
                            <p>Registry Officer</p>
                          </td>
                          <td>
                            <p>Change to coding convention</p>
                          </td>
                          <td>
                            <p>24/03/20</p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>V3.4</p>
                          </td>
                          <td>
                            <p>Senior Quality Officer</p>
                          </td>
                          <td>
                            <p>Further naming convention clarifications</p>
                          </td>
                          <td>
                            <p>31/03/20</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  data() {
    return {};
  }
};
</script>

<style scoped>
.ulaw-logo {
  width: 120px;
}
.margin-10 {
  margin: 10px;
}
section {
  padding-top: 5rem;
}
</style>
